import { render } from "./ActionEmailConfig.vue?vue&type=template&id=406bd81a"
import script from "./ActionEmailConfig.vue?vue&type=script&lang=js"
export * from "./ActionEmailConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/flow/evaluate/ActionEmailConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "406bd81a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('406bd81a', __exports__)) {
    api.reload('406bd81a', __exports__)
  }
  
  module.hot.accept("./ActionEmailConfig.vue?vue&type=template&id=406bd81a", () => {
    api.rerender('406bd81a', render)
  })

}


export default __exports__